import React from 'react';
import WidgetItem from '../../widget-grid/jsx/WidgetItem';

/**
 * This is only used on the initial webpack / React Lazy load of the component
 */
export default function CalendarLoadingState({ title }) {
    return (
        <WidgetItem title={title} className="calendar-widget-item">
            <div className="no-wysiwyg calendar-wrapper__overlay">
                <div className="no-wysiwyg calendar">
                    <div className="calendar-loading">
                        <div className="calendar-loading__label">Loading...</div>
                        <div className="calendar-loading__row calendar-loading__row--header">
                            <div className="calendar-loading__shadow-header" />
                            <div className="calendar-loading__shadow-header" />
                            <div className="calendar-loading__shadow-header" />
                            <div className="calendar-loading__shadow-header" />
                            <div className="calendar-loading__shadow-header" />
                        </div>
                        {[...Array(4)].map((junk, i) => {
                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div key={i} className="calendar-loading__row">
                                    <div className="calendar-loading__shadow" />
                                    <div className="calendar-loading__shadow" />
                                    <div className="calendar-loading__shadow" />
                                    <div className="calendar-loading__shadow" />
                                    <div className="calendar-loading__shadow" />
                                </div>
                            );
                        })}
                        <div className="calendar-loading__row">
                            <div className="calendar-loading__shadow" />
                            <div className="calendar-loading__shadow" />
                            <div className="calendar-loading__shadow" />
                            <div className="calendar-loading__shadow calendar-loading__shadow--empty" />
                            <div className="calendar-loading__shadow calendar-loading__shadow--empty" />
                        </div>
                    </div>
                </div>
            </div>
        </WidgetItem>
    );
}
